var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 9.5999C8.42425 9.5999 8.83121 9.43133 9.13127 9.13127C9.43133 8.83121 9.5999 8.42425 9.5999 7.9999C9.5999 7.57556 9.43133 7.16859 9.13127 6.86853C8.83121 6.56847 8.42425 6.3999 7.9999 6.3999C7.57556 6.3999 7.16859 6.56847 6.86853 6.86853C6.56847 7.16859 6.3999 7.57556 6.3999 7.9999C6.3999 8.42425 6.56847 8.83121 6.86853 9.13127C7.16859 9.43133 7.57556 9.5999 7.9999 9.5999Z",
    fill: "#B7B9CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.366211 7.9999C1.38541 4.7543 4.41741 2.3999 7.99981 2.3999C11.5822 2.3999 14.6142 4.7543 15.6334 7.9999C14.6142 11.2455 11.5822 13.5999 7.99981 13.5999C4.41741 13.5999 1.38541 11.2455 0.366211 7.9999ZM11.1998 7.9999C11.1998 8.8486 10.8627 9.66253 10.2626 10.2626C9.66244 10.8628 8.8485 11.1999 7.99981 11.1999C7.15112 11.1999 6.33719 10.8628 5.73707 10.2626C5.13695 9.66253 4.79981 8.8486 4.79981 7.9999C4.79981 7.15121 5.13695 6.33728 5.73707 5.73716C6.33719 5.13704 7.15112 4.7999 7.99981 4.7999C8.8485 4.7999 9.66244 5.13704 10.2626 5.73716C10.8627 6.33728 11.1998 7.15121 11.1998 7.9999V7.9999Z",
    fill: "#B7B9CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.63c2cf1dc1b3d108d5de26f7406e4274.svg";
export { ForwardRef as ReactComponent };